import { PAGE_SLUG } from 'src/api/endpoints/contentHub/constants';

export const LEGAL_DOCUMENT_ROUTES = {
  [PAGE_SLUG.termsAndConditions]: PAGE_SLUG.termsAndConditions,
  [PAGE_SLUG.privacyPolicy]: PAGE_SLUG.privacyPolicy,
  [PAGE_SLUG.cookiePolicy]: PAGE_SLUG.cookiePolicy,
};
